type CancellableRequest = {
  abort: () => void;
  then?: (
    onFulfilled?: () => void,
    onRejected?: () => void
  ) => unknown;
};

const activeRequests: Record<string, CancellableRequest> = {};

export const registerApiRequest = (
  cancelKey: string | undefined,
  request: CancellableRequest
): void => {
  if (!cancelKey) {
    return;
  }

  activeRequests[cancelKey] = request;

  const cleanup = () => {
    if (activeRequests[cancelKey] === request) {
      delete activeRequests[cancelKey];
    }
  };

  if (typeof request.then === 'function') {
    request.then(cleanup, cleanup);
  }
};

export const abortApiRequest = (cancelKey?: string): void => {
  if (!cancelKey || !activeRequests[cancelKey]) {
    return;
  }

  activeRequests[cancelKey].abort();
  delete activeRequests[cancelKey];
};
